import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { UsuarioService } from '../services/api/cadastros/UsuariosService';

type TAutoCompleteOption = {
  iduser: string;
  label: string;
}
interface IAutoCompleteParceiroProps {
  isExternalLoading?: boolean;
  disabled?: boolean;
  uuiduser?: (novoTextoselect: string | undefined) => void;
}

export const AutoCompleteVendedor: React.FC<IAutoCompleteParceiroProps> = ({ isExternalLoading = false, disabled = false, uuiduser}) => {

  const { fieldName, registerField, defaultValue, error, clearError } = useField('iduser');

  const { debounce } = useDebounce(); 

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);
  useEffect(() => {
  if (defaultValue) {
    setSelectedId(defaultValue);
  }
}, [defaultValue]);

  useEffect(() => {
    setIsLoading(true);
  
    debounce(() => {
      UsuarioService.getAllList(busca, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(vendedor => ({ iduser: vendedor.iduser, label: vendedor.nome})));
          }
        });
    });
  }, [busca, selectedId]);
 
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.iduser === selectedId); 
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);
   
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading || disabled}
      value={autoCompleteSelectedOption}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => { setSelectedId(newValue?.iduser); uuiduser?.(newValue?.iduser); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Vendedor"
          error={!!error}  
          helperText={error}
        />
      )}
    />
  );
};